import Inputmask from 'inputmask'

export const VueInputMask = {
  install: function (Vue, options) {
    Vue.directive('mask', {
      bind: function (el, binding) {
        const { mask, ...options } = binding.value
        Inputmask(mask, { ...options, unmaskAsNumber: true }).mask(el)
      }
    })
  }
}
